export default __webpack_public_path__ + "static/media/slider-image.87fb2ad0.png";